module.exports = __webpack_public_path__ + "eff37f1a0137df5701aed5e83f94f057.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/header/logo.png
// module id = ./assets/images/header/logo.png
// module chunks = 0